import Vue from 'vue';
import Vuex from 'vuex';
import portalDefaultStateObject from './PortalDefaultStateObject';

console.log(portalDefaultStateObject);

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    portalStateObject: { ...portalDefaultStateObject },
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      responseReceived: false,
    },
  },
  getters: {
    loggedIn(state) {
      return state.portalStateObject.user.loggedIn;
    },
    online(state) {
      console.log('online :: ', state.portalStateObject.labs.online);
      return state.portalStateObject.labs.online;
    },
    showWizard(state, getters) {
      return !(getters.online
        && getters.licenseActive
        && Object.values(getters.labs).some((v) => v.installed));
    },
    licenseActive(state, getters) {
      const stringExpires = getters.licenseDetails.end_date;
      if (!stringExpires) {
        return false;
      }
      const dateExpires = new Date(stringExpires);
      const timeLeft = dateExpires - Date.now();
      if (timeLeft < 0) {
        return false;
      }
      return Object.values(getters.authorizations).some((v) => v);
    },
    licenseDetails(state, getters) {
      if (!(getters.user && getters.user.license && getters.user.license.length > 0)) {
        return {};
      }
      return getters.user.license[0];
    },
    labs(state) {
      return state.portalStateObject.labs.apps;
    },
    authorizations(state) {
      return state.portalStateObject.user.authorizations;
    },
    user(state) {
      return state.portalStateObject.user;
    },
    announcements(state) {
      return state.portalStateObject.main.announcements;
    },
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      console.log('SOCKET_ONOPEN', state);
      Vue.prototype.$socket = event.currentTarget;
      const heartbeatMessage = {
        sender: localStorage.sender,
        target: localStorage.target,
        action: 'heartbeat_request',
        groups: [],
        hash: '',
        organization: 1,
        payload: {},
      };
      Vue.prototype.$socket.send(JSON.stringify(heartbeatMessage));
    },
    SOCKET_ONCLOSE(state, event) {
      console.log('SOCKET_ONCLOSE_EVENT :: ', event);
      // state.socket.responseReceived = false;
      // window.setTimeout(() => {
      //   if (!state.socket.responseReceived) {
      //     this.commit('SET_DEFAULT_LABS');
      //   }
      // }, 3000);
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      try {
        const data = JSON.parse(message.data);
        if (typeof data.action !== 'undefined' && data.action === 'heartbeat_response') {
          if (typeof data.sender !== 'undefined') localStorage.target = data.sender;
        }
        if (data.ping) {
          console.log('SOCKET_ONMESSAGE :: ping :: ', data.ping);
          const pongMsg = {
            pong: true,
            uid: localStorage.sender,
          };
          Vue.prototype.$socket.send(JSON.stringify(pongMsg));
        } else if (data.action === 'heartbeat_response') {
          console.log('SOCKET_ONMESSAGE :: heartbeat_response :: ', data.payload);
          state.socket.responseReceived = true;
          Vue.set(state.portalStateObject, 'labs', { ...data.payload });
        } else if (data.action === 'goodbye') {
          console.log('SOCKET_ONMESSAGE :: goodbye :: ', data);
          this.commit('SET_DEFAULT_LABS');
        } else { console.log('SOCKET_ONMESSAGE :: data :: unknown :: action :: ', data); }
      } catch (error) {
        console.log('ws :: data :: conversion :: error :: ', error);
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
    SET_USER(state, user) {
      Vue.set(state.portalStateObject, 'user', user);
    },
    SET_AUTHORIZATIONS(state, authorizations) {
      Vue.set(state.portalStateObject.labs, 'authorizations', authorizations);
    },
    SET_DEFAULT_LABS(state) {
      console.log('Store :: mutations :: SET_DEFAULT_LABS');
      Vue.set(state.portalStateObject, 'labs', { ...portalDefaultStateObject.labs });
    },
  },
  actions: {
    sendMessage(context, message) {
      const blzMessage = {
        target: localStorage.target,
        sender: localStorage.sender,
        action: message.action,
        groups: [],
        hash: '',
        support: {
          target: undefined,
          enabled: false,
        },
        organization: 1,
        payload: {},
      };
      blzMessage.payload = message.payload;
      console.log('Store Send Message', blzMessage);
      let stringMessage = blzMessage;
      if (typeof stringMessage === 'object') {
        stringMessage = JSON.stringify(blzMessage);
      }
      if (message.action === 'heartbeat_request') {
        Vue.set(context.state.socket, 'responseReceived', false);
        window.setTimeout(() => {
          if (!context.state.socket.responseReceived) {
            context.commit('SET_DEFAULT_LABS');
          }
        }, 3000);
      }
      Vue.prototype.$socket.send(stringMessage);
    },
    updateUser(context, message) {
      console.log('store :: updateUser :: ', message);
    },
    updateAuthorizations(context) {
      console.log('store :: updateAuthorizations');
      if (typeof localStorage.target === 'undefined') return;
      const postData = {
        target: localStorage.target,
        sender: localStorage.sender,
      };
      const url = 'https://portal.beyondlabz.com/portal/connect_authorizations/set';
      Vue.prototype.$http
        .post(url, postData)
        .then((resp) => {
          if (resp.status === 200) {
            context.commit('SET_AUTHORIZATIONS', resp.data);
            const message = {
              action: 'update_authorizations',
              payload: {},
            };
            context.dispatch('sendMessage', message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  modules: {
  },
});
